/**
 * OMR Card Preview with Layout Options
 * Allows choosing between A4 (single card) or 2x1 A5 (two cards per page)
 */

import React, { useRef, useState } from 'react';
import { X, Printer } from 'lucide-react';
import OMRCardLayout from './OMRCardLayout';
import OMRCardLayout2x1 from './OMRCardLayout2x1';
import styles from './OMRCardPreview.module.css';

const OMRCardPreview2x1 = ({
  isOpen = false,
  onClose = () => {},
  examId = 1,
  examName = 'Exame',
  questions = [],
}) => {
  const printRef = useRef(null);
  const [layout, setLayout] = useState('A4'); // 'A4' or '2x1'

  if (!isOpen) {
    return null;
  }

  const handlePrint = () => {
    if (printRef.current) {
      const printWindow = window.open('', '', 'width=800,height=600');
      printWindow.document.write(printRef.current.innerHTML);
      printWindow.document.close();

      // Wait for content to render, then print
      setTimeout(() => {
        printWindow.print();
      }, 250);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.modalHeader}>
          <h2>Pré-visualização do Cartão-Resposta</h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Fechar"
          >
            <X size={24} />
          </button>
        </div>

        {/* Layout Selector */}
        <div
          style={{
            padding: '12px 20px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Formato:</label>
          <button
            onClick={() => setLayout('A4')}
            style={{
              padding: '8px 16px',
              backgroundColor: layout === 'A4' ? '#007bff' : '#f0f0f0',
              color: layout === 'A4' ? '#fff' : '#000',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            A4 (1 cartão por página)
          </button>
          <button
            onClick={() => setLayout('2x1')}
            style={{
              padding: '8px 16px',
              backgroundColor: layout === '2x1' ? '#28a745' : '#f0f0f0',
              color: layout === '2x1' ? '#fff' : '#000',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            A5 (2 cartões por página A4)
          </button>
        </div>

        {/* Preview area */}
        <div className={styles.previewArea}>
          <div ref={printRef} className={styles.previewContent}>
            {layout === 'A4' ? (
              <OMRCardLayout
                examId={examId}
                examName={examName}
                questions={questions}
              />
            ) : (
              <OMRCardLayout2x1
                examId={examId}
                examName={examName}
                questions={questions}
              />
            )}
          </div>
        </div>

        {/* Footer with actions */}
        <div className={styles.modalFooter}>
          <button
            className={styles.printButton}
            onClick={handlePrint}
          >
            <Printer size={18} />
            Imprimir
          </button>
          <button
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>

        {/* Info box */}
        {layout === '2x1' && (
          <div
            style={{
              padding: '12px 20px',
              backgroundColor: '#e3f2fd',
              borderTop: '1px solid #90caf9',
              fontSize: '12pt',
              color: '#1976d2',
            }}
          >
            💡 <strong>Dica:</strong> Imprima em A4, corte ao meio pela linha tracejada, e use como cartões A5!
          </div>
        )}
      </div>
    </div>
  );
};

export default OMRCardPreview2x1;
